// extracted by mini-css-extract-plugin
export default {"Semibold":"B6Mo93PW"};